import { useState, useEffect, Fragment } from 'react';
import { withAgentPage, withLayout } from 'hocs';
import compose from 'recompose/compose';
import { useParams } from 'react-router';
import CardProduct from 'newComponents/cardProduct/addCart';
import CardTitleEvent from 'newComponents/CardTitleEvent';
// import ViewsFilter from 'newComponents/ViewsFilter';
import ResultsFilter from 'newComponents/Results';
import { useStore } from 'store';
import { hideLoader, showLoader } from 'store/actions/commons';
import useEventGifts from 'newHooks/useEventGifts';
import GiftsHeaderCart from 'newComponents/GiftsHeader/GiftsHeaderCart';
import OnlyStore from 'newComponents/cardProduct/addOnlyStore';
import styles from './styles.module.sass';


const NewGuestLanding = () => {
    const [, dispatch] = useStore((state) => state.giftTable.giftTable);
    
    const { eventId } = useParams();
    
    const {
        getEventTable,
        responseTable,
        responseTableStore,
        responseEmpryGifts,
        products,
        total,
        categories,
        handleOrdenar,
        handleCategorias
    } = useEventGifts()

    const [ addProduct, setAddProduct ] = useState(false)
    const [ listCarts, setListCarts ] = useState(false)
    const [ event_id, setEvent_id ] = useState(eventId)
    
    useEffect(()=>{
        getEventTable(eventId)
        dispatch(showLoader());
    },[])

    useEffect(()=>{
        if(products){
            // console.log('products: ',products)
            dispatch(hideLoader());
        }else if(responseEmpryGifts){
            dispatch(hideLoader());
        }
    },[ products, responseEmpryGifts ])

    useEffect(()=>{
        if(listCarts){
            if(listCarts !== 404){
                const cart_id = listCarts[0]?.cart_id
                setEvent_id(cart_id)
            }else{
                setEvent_id(eventId)
            }
        }
    },[ listCarts ])

    const [totalLength, setTotalLength] = useState(0)
    useEffect(()=>{
        if(total){
            const totalF = total?.filter( product => product?.quantity_for_gift >= 1 )
            setTotalLength(totalF?.length)
        }
    },[total])

    const [ activeView, ] = useState('mosaico')


    return(
        <>
            <GiftsHeaderCart
                eventId={eventId}
                products={total}
                addProduct={addProduct}
                setListCarts={setListCarts}
            />

            <CardTitleEvent 
                responseTable={responseTable}
            />

            {responseTable
                ? 
                    responseTable?.status !== 'Close'
                        ?
                            <>
                                <div className={ `${styles?.sectionFilters} containerPortal`}>
                                    <h1>Mesa de regalos</h1>
                                    <div className={styles?.filtersGifts}>
                                        <ResultsFilter cantResults={totalLength} />
                                        {/* <ViewsFilter setActiveView={setActiveView} /> */}

                                        <div className={styles?.styleSelec}>
                                            <select onChange={handleCategorias}>
                                                <option value="Categorías">Categorías</option>
                                                {categories
                                                    ? categories.map(category => <option key={category} value={category}>{category}</option>)
                                                    : null
                                                }
                                            </select>
                                        </div>

                                        <div className={styles?.styleSelec}>
                                            <select  onChange={handleOrdenar}>
                                                <option value="1">Ordenar por precio</option>
                                                <option value="2">Mayor precio</option>
                                                <option value="3">Menor precio</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className={`${styles?.contProductsCat} containerPortal`}>
                                    {products
                                        ?
                                            products.map(categoriaData => (
                                                <Fragment key={categoriaData?.categoria}>
                                                    <div className={styles?.titleCategory}>{categoriaData?.categoria ? 'Categoría:' : ''} {categoriaData?.categoria}</div>
                                                    <div className={ `${styles?.contentProductsGest} ${activeView} containerPortal` }>
                                                        {categoriaData?.product
                                                            ? categoriaData?.product.map( product => 
                                                                product.quantity_for_gift >= 1 
                                                                    ?
                                                                        <CardProduct 
                                                                            key={product?.id}
                                                                            eventId={event_id}
                                                                            eventoNo={eventId}
                                                                            item={product}
                                                                            productsToCart={listCarts[0]?.products}
                                                                            setAddProduct={setAddProduct}
                                                                            responseTable={responseTable}
                                                                        /> 
                                                                    : null
                                                            )
                                                            : null
                                                        }
                                                    </div>
                                                </Fragment>
                                            ))
                                        : null
                                    }
                                    
                                    {responseTableStore?.length >= 1
                                        ?
                                            <>
                                                <div className={styles?.titleCategory}>Categoría: Solo disponible en tienda</div>
                                                <div className={ `${styles?.contentProductsGest} ${activeView} containerPortal` }>
                                                    {responseTableStore?.length >= 1
                                                        ?
                                                            responseTableStore?.map(store => (
                                                                    <OnlyStore producto={store} typeCard="userView" />
                                                                )
                                                            )
                                                        : null
                                                    }
                                                </div>
                                            </>
                                        : null
                                    }
                                    
                                    {responseEmpryGifts
                                        ? <div className={styles?.noProducts}><div className={styles?.imageNoGifts} />Aún no hay regalos en este evento</div>
                                        : null
                                    }       
                                </div>
                            </>
                        : <div className={styles?.noProducts}><div className={styles?.imageNoTables} />¡Muchas gracias! El evento ha terminado</div>
                : <div className={styles?.emptyDiv} />
            }
        </>
    )
}

export default compose(
    withLayout,
    withAgentPage({ fetchTableInfo: true })
)(NewGuestLanding);